var SearchBarFilterType = /* @__PURE__ */ function(SearchBarFilterType2) {
  SearchBarFilterType2["TAG"] = "tag";
  SearchBarFilterType2["LOCATION"] = "location";
  SearchBarFilterType2["CONTENT_TYPE"] = "content_type";
  return SearchBarFilterType2;
}({});

export { SearchBarFilterType };
//# sourceMappingURL=searchbar.types.js.map
